import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getValue'
})
export class GetValuePipe implements PipeTransform {

  transform(items: any[], attr: string, value: string, key: string): any {
    return items != null ? items.find(x => x[attr] == value)[key] : '';
  }

}
